import { RequestService } from "../../../../common/services/RequestService";
import { EDIT_CUSTOMER } from "../constants";
import { adjustEditCustomerData } from "../customerCard/adjustEditCustomerData";
import { adjustCustomerByIdData } from "../customerCard/adjustCustomerByIdData";

export const editCustomer = async (payload, profileId, userId, profileCustomerId) => {
  const response = await RequestService.put(EDIT_CUSTOMER + profileCustomerId,
    adjustEditCustomerData(payload, profileId, userId)
  );

  return response && response.data && adjustCustomerByIdData(response.data);
};
